import React from "react"
import Family from "../../images/careers/Family.svg"
import Wellness from "../../images/careers/Wellness.svg"
import Vacation from "../../images/careers/Vacation.svg"
import Resources from "../../images/careers/Resources.svg"
import Healthcare from "../../images/careers/Healthcare.svg"

const benefits = [
  {
    icon: Family,
    title: "Family",
    description: "Generous parental and family leave",
  },
  {
    icon: Wellness,
    title: "Wellness",
    description: "Monthly gym and fitness allowance",
  },
  {
    icon: Vacation,
    title: "Vacation",
    description: "Unlimited vacation and time-off policy",
  },
  {
    icon: Resources,
    title: "Resources",
    description:
      "401K plan, flexible spending account, commuting support, and monthly phone bill reimbursement",
  },
  {
    icon: Healthcare,
    title: "Healthcare",
    description: "100% company-paid health and affordable dental insurance",
  },
]

const BenefitsSection = () => (
  <section
    className="section mt-6"
    style={{
      background: "linear-gradient(180deg, #F1FCFF 51.44%, #FFFFFF 100%)",
    }}
  >
    <div className="container p-5">
      <div className="columns benefits-container" style={{ gap: "120px" }}>
        <div className="column is-3">
          <h1
            className="is-size-1 is-size-3-mobile has-text-weight-semibold has-text-purple"
            style={{ marginBottom: "auto", lineHeight: 0.5 }}
          >
            Benefits
          </h1>
        </div>
        <div className="column is-9">
          <ul className="benefits-list">
            {benefits.map((b, i) => (
              <li key={i} className="benefit-item">
                <div className="benefit-icon">
                  <img src={b.icon} alt="" aria-hidden="true" />
                </div>
                <div className="benefit-copy">
                  <p className="benefit-title has-text-weight-semibold is-6 is-size-4-desktop has-text-purple mb-1">
                    {b.title}
                  </p>
                  <p
                    className="benefit-description is-5 is-size-5-desktop has-text-purple has-text-weight-light mt-1"
                    style={{ minHeight: "55px", maxWidth: "50ch" }}
                  >
                    {b.description}
                  </p>
                </div>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  </section>
)

export default BenefitsSection
